/**
 * Cổng trang chủ: chưa đăng nhập → chọn vai trò; đã chọn role → redirect vào khu vực tương ứng.
 */
import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../hooks/redux'
import RoleSelectPage from '../pages/RoleSelectPage'

export default function RoleSelectGate() {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth)

  if (!isAuthenticated || !user) {
    return <RoleSelectPage />
  }

  const isStaff = ['secretary', 'judge', 'admin', 'chief_judge'].includes(user.role)
  return <Navigate to={isStaff ? '/workspace' : '/cases'} replace />
}
